import { EndpointsOptionsMap } from '../system';
import * as profileApi from './profile';

export type ProfileApiEndpointTypes = EndpointsOptionsMap<typeof profileApi>;
export { profileApi };
